<template>
  <div style="min-height: 100px" v-loading="loading">
    <div v-if="purchaseInfo">
      <el-card shadow="hover">
        <div style="padding: 10px">
          <warehouse-purchase-info :purchaseInfo="purchaseInfo" />
          <div style="margin-top: 10px" v-if="purchaseInfo.optStatus != 3">
            <el-button :size="$xUISize" @click="editClick" type="default">
              编辑
            </el-button>
            <el-button
              v-if="purchaseInfo.inboundGoodsCount <= 0"
              :size="$xUISize"
              @click="cancelClick"
              type="danger"
            >
              取消
            </el-button>
          </div>
        </div>
      </el-card>
      <div>
        <x-tab v-model="tabName" :tabs="tabs" :query="tabParams" :params="tabParams" />
      </div>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="getDetail" size="small"> 重新加载 </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.purchase-detail {
  margin-top: 20px;
}
</style>

<script>
import warehousePurchaseInfo from "@/components/business/warehousePurchaseInfo.vue";
import purchaseFromPage from "./__arranged_purchase_form.vue";
import detailItemList from "./__arranged_purchase_item_list.vue";

export default {
  components: {
    warehousePurchaseInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    tabParams() {
      if (!this.purchaseInfo) {
        return {};
      }
      return {
        guid: this.purchaseInfo.guid,
        purchaseGuid: this.purchaseInfo.guid,
        storeGuid: this.purchaseInfo.storeGuid,
      };
    },
    tabs() {
      if (!this.purchaseInfo) {
        return [];
      }
      let tabList = [
        {
          name: "purchase-item-list",
          label: "采购清单",
          component: detailItemList,
          interval: true,
        },
      ];
      return tabList;
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      purchaseInfo: null,
      printLoading: false,
      cancelLoading: false,
      tabName: "",
    };
  },
  methods: {
    editClick() {
      if (!this.purchaseInfo) {
        return;
      }
      this.$drawer.openDrawer({
        title: "编辑采购单信息",
        refresh: () => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        },
        component: purchaseFromPage,
        params: {
          guid: this.purchaseInfo.guid,
          storeGuid: this.purchaseInfo.storeGuid,
        },
      });
    },
    purchaseClick() {
      if (!this.purchaseInfo) {
        return;
      }
      this.$confirm("确认标记为已采购？", "确认", {
        type: "info",
      }).then(() => {
        this.requestApi(
          "biz.warehouse.purchase.info.purchase",
          {
            guid: this.purchaseInfo.guid,
          },
          {
            showError: true,
          }
        ).then(() => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        });
      });
    },
    confirmedClick() {
      this.$confirm("确认要货，确认后将通知采购？", "确认", {
        type: "info",
      }).then(() => {
        this.requestApi(
          "biz.warehouse.purchase.info.confirmed",
          {
            guid: this.purchaseInfo.guid,
            storeGuid: this.purchaseInfo.storeGuid,
          },
          {
            showError: true,
          }
        ).then(() => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        });
      });
    },
    cancelClick() {
      if (!this.purchaseInfo) {
        return;
      }
      this.$confirm("确认取消当前采购单？", "确认", {
        type: "error",
      }).then(() => {
        this.requestApi(
          "biz.warehouse.purchase.info.cancel",
          {
            guid: this.purchaseInfo.guid,
          },
          {
            showError: true,
          }
        ).then(() => {
          this.$drawer.refreshDrawer();
          this.getDetail();
        });
      });
    },
    getDetail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.purchaseInfo = null;
      return this.requestApi("biz.warehouse.purchase.info.detail", {
        guid: this.pageParams.guid,
        storeGuid: this.pageParams.storeGuid,
      })
        .then((resp) => {
          this.purchaseInfo = resp.data;
        })
        .catch((err) => {
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.tabName = this.pageParams.tabName;
    this.getDetail();
  },
};
</script>
